module.exports = __webpack_public_path__ + "img/کارت-ویزیت-لمینت-برجسته-طلا-کوب.bda54ad7.png";